/*
 * @Author: cryi.liu
 * @Date: 2020-04-30 09:35:30
 * @LastEditTime: 2020-06-17 14:23:55
 * @Description: write you description
 */
import Vue from 'vue';
import Vuex from 'vuex';
import appStore from './modules/appStore';
import authStore from './modules/authStore';
import footStore from './modules/footStore';
import pageStore from './modules/pageStore';
import libraryStore from './modules/libraryStore';
import createPaperStore from './modules/createPaperStore';
import onlineExamStore from './modules/onlineExamStore';
import answerMarkStore from './modules/answerMarkStore';

Vue.use(Vuex);

export default new Vuex.Store({
  // 设置严格模式
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    appStore,
    authStore,
    footStore,
    pageStore,
    libraryStore,
    createPaperStore,
    onlineExamStore,
    answerMarkStore,
  },
});
